var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.893 2.874A1.712 1.712 0 0 1 3.248 4.12c-.766 0-1.438-.51-1.646-1.246h-1a.466.466 0 1 1 0-.933h1a1.709 1.709 0 0 1 3.291 0h6.766a.466.466 0 1 1 0 .933H4.893ZM3.245 1.628a.78.78 0 1 0 0 1.56.78.78 0 0 0 0-1.56ZM4.893 11.593a1.712 1.712 0 0 1-1.645 1.246c-.766-.001-1.438-.51-1.646-1.246h-1a.466.466 0 0 1 0-.933h1a1.709 1.709 0 0 1 3.291 0h6.766a.466.466 0 1 1 0 .933H4.893Zm-1.648-1.246a.78.78 0 1 0 0 1.559.78.78 0 0 0 0-1.56ZM7.368 6.302a1.712 1.712 0 0 1 1.646-1.245c.765 0 1.437.51 1.645 1.245h1a.466.466 0 1 1 0 .933h-1a1.709 1.709 0 0 1-3.29 0H.602a.466.466 0 0 1 0-.933h6.765ZM9.014 7.55a.78.78 0 1 0 0-1.56.78.78 0 0 0 0 1.56Z",
    fill: "#58B847"
  })));
};
export default SvgFilter;